export default "__VITE_ASSET__B55FwddD__"